// extracted by mini-css-extract-plugin
module.exports = {"comp":"CompareA_comp__VxaQL","price":"CompareA_price__kTdQB"};